<template>
    <div class="flex">
        <Button :text="text"
            @click="$emit('left')"
            :color="color"
            :short="true"
            style="
                border-top-right-radius: 0 !important;
                border-bottom-right-radius: 0 !important;
            "
            :style="noBorder ? 'border-width: 0 !important' : ''"
        />

        <Button :icon="icon"
            @click="$emit('right')"
            :color="color"
            :short="true"
            :class="`${dividerColor}`"
            style="
                border-top-left-radius: 0 !important;
                border-bottom-left-radius: 0 !important;
                border-width: 0 0 0 1px !important;
                border-style: solid;
            "
        />
    </div>
</template>

<script>
import { Button } from '@sportsrecruits/playbook'

export default {
    components: {
        Button,
    },

    props: {
        color: { type: String, default: 'blue' },
        text: { type: String, required: true },
        icon: { type: String, required: true },
        noBorder: { type: Boolean, required: false, default: false }
    },

    computed: {
        dividerColor() {
            return this.color === 'white' || this.color === 'blueOnWhite' ? 'border-blue-300' 
            : 'border-white'
        },
    }
}
</script>
